const AT_KEY = "cb_at";
const RT_KEY = "cb_rt";

export const tokenStore = {
  getAccessToken: () => localStorage.getItem(AT_KEY),
  getRefreshToken: () => localStorage.getItem(RT_KEY),
  setTokens: (at: string, rt: string) => {
    localStorage.setItem(AT_KEY, at);
    localStorage.setItem(RT_KEY, rt);
  },
  clearTokens: () => {
    localStorage.removeItem(AT_KEY);
    localStorage.removeItem(RT_KEY);
  },
};
